export default {
    _prefix: "qualityFormEditor.question",
    labels: {
        clearAnswer: "Clear Answer",
        addComments: "Add Comments",
        question: "Question",
        helpText: {
            title: "Help Text",
            content: "Additional Guidance",
            nps: {
                followUpExplanation: "Follow-Up Question Prompt",
                fieldIsEmptyError: "This field is required.",
                explanationIsTooLengthy: (maxExplanationPromptLength: {
                    maxExplanationPromptLength: number;
                }) =>
                    "Explanation prompt text may have at most {{maxExplanationPromptLength}} characters.",
            },
        },
        points: "Points",
        addEvaluationAssistance: "Add Evaluation Assistance Condition",
        addAnswer: "Add Answer",
        answerOptions: "Answers",
        multipleSelect: {
            addAnswer: "Add Option",
            answerOptions: "Options",
        },
        logic: {
            title: "Logic",
            displayConditionally: "Display This Question Conditionally",
            includeConditionally: "Include This Question Conditionally",
        },
        scoring: {
            title: "Scoring",
            criticalQuestion: "Critical Question",
            fatalQuestion: "Fatal Question",
            critical: "Critical",
            fatal: "Fatal",
        },
        delete: "Delete",
        done: "Done",
        saveTemplate: "Save As Template",
        textArea: "Text Area ...",
        answerOptionTextInput: "Answer Option Text Box",
        defaultAnswer: "Default Answer",
        tooltip: {
            userDefinedDefaultAnswer:
                "Only one of the answer options can be selected as a default answer",
        },
        cannotDeleteMCQOption: (minAnswerOptionCount: {
            minAnswerOptionCount: number;
        }) =>
            "A multiple choice question must contain at least {{minAnswerOptionCount}} answers",
        cannotDeleteMSQOption: (minAnswerOptionCount: {
            minAnswerOptionCount: number;
        }) =>
            "A multiple select question must contain at least {{minAnswerOptionCount}} option",
        criticalQuestionAnswerLimitReached: (criticalAnswerOptionCount: {
            criticalAnswerOptionCount: number;
        }) =>
            "A critical question can only have {{criticalAnswerOptionCount}} answers",
        answerLimitReached: (maxAnswerOptionCount: {
            maxAnswerOptionCount: number;
        }) =>
            "Multiple choice questions may not have more than {{maxAnswerOptionCount}} answer options",
        aiScoringAnswerLimitReached: (maxAIScoringAnswerOptionCount: {
            maxAIScoringAnswerOptionCount: number;
        }) =>
            "Multiple choice questions with AI Scoring enabled may not have more than {{maxAIScoringAnswerOptionCount}} answer options",
        multipleSelectAnswerLimitReached: (maxAnswerOptionCount: {
            maxAnswerOptionCount: number;
        }) =>
            "Multiple select questions may not have more than {{maxAnswerOptionCount}} answer options",
    },
    screenreader: {
        questionMoveUp: (data: {
            currentQuestionGroupIndex: number;
            currentPosition: number;
            newPosition: number;
            questionName: string;
        }) =>
            "Question {{currentQuestionGroupIndex}}.{{currentPosition}} - {{questionName}} moved up to position {{currentQuestionGroupIndex}}.{{newPosition}}",
        questionMoveDown: (data: {
            currentQuestionGroupIndex: number;
            currentPosition: number;
            newPosition: number;
            questionName: string;
        }) =>
            "Question {{currentQuestionGroupIndex}}.{{currentPosition}} - {{questionName}} moved down to position {{currentQuestionGroupIndex}}.{{newPosition}}",
        answerMoveUp: (data: {
            currentPosition: number;
            newPosition: number;
            answerOptionName: string;
        }) =>
            "Answer option {{currentPosition}}: {{answerOptionName}} moved up to position {{newPosition}}",
        answerMoveDown: (data: {
            currentPosition: number;
            newPosition: number;
            answerOptionName: string;
        }) =>
            "Answer option {{currentPosition}}: {{answerOptionName}} moved down to position {{newPosition}}",
    },
    errors: {
        requiredField: "This field is required.",
        questionNameTooLong: (maxQuestionNameLength: {
            maxQuestionNameLength: number;
        }) =>
            "Question text may have at most {{maxQuestionNameLength}} characters.",
        helpTextTooLong: (maxHelpTextLength: { maxHelpTextLength: number }) =>
            "Question help text may have at most {{maxHelpTextLength}} characters.",
        emptyPoints: "Points must not be empty.",
        decimalPoints: "Points must be a valid integer.",
        answerOptionTextTooLong: (maxAnswerTextLength: {
            maxAnswerTextLength: number;
        }) =>
            "Answer option text may have at most {{maxAnswerTextLength}} characters.",
        answerPointsOverUpperLimit: (maxAnswerOptionPoints: {
            maxAnswerOptionPoints: number;
        }) =>
            "Answer option may not have a value more than {{maxAnswerOptionPoints}}.",
        defaultAnswerRequiredForUserDefined:
            'When "Answers Default To" is set to "User Defined", one answer must be set as the "Default Answer"',
    },
};
